;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { Dayjs } from 'dayjs';

import { getListingPosition } from './getListingPosition';
import { Listing, ListingPositionEnum } from '@/lib/types/api/multi-livestream';

// This function filters out listings that are not in the schedule window.
// We run each listing through getListingPostion and toss out the ones that
// are not in the schedule window.
// Additionally we add the listing position to the listing object.
const filterListings = (
  listings: Listing[],
  now: Dayjs,
  scheduleStart: Dayjs,
  scheduleEnd: Dayjs
) => {
  const filteredListings: Array<Listing> = [];

  listings.forEach((listing) => {
    const listPostion = getListingPosition(
      listing,
      now,
      scheduleStart,
      scheduleEnd
    );
    // filter out the listings that are not in the schedule window
    if (
      listPostion !== ListingPositionEnum.notInSchedule &&
      listPostion !== ListingPositionEnum.startsAfterScheduleEnd &&
      listPostion !== ListingPositionEnum.startsBeforeScheduleStartAndEnded
    ) {
      // and add the listing position to the listing object
      filteredListings.push({ ...listing, listing_position: listPostion });
    }
  });

  return filteredListings;
};

export { filterListings };
